import React from 'react'
import { Route, Routes } from 'react-router-dom'
import LoadableComponent from '../../utils/loadable'

//参数一定要是函数，否则不会懒加载，只会代码拆分
// Home page
const Home = LoadableComponent(() => import('../../containers/Index/Home/index'))
const Template = LoadableComponent(() => import('../../containers/Index/Template/index'))
const Solution = LoadableComponent(() => import('../../containers/Index/Solution/index'))
const Library = LoadableComponent(() => import('../../containers/Index/Library/index'))
const Tutorial = LoadableComponent(() => import('../../containers/Index/Tutorial/index'))
const TutorialDetail = LoadableComponent(() => import('../../containers/Index/Tutorial/detail'))

class ContentMain extends React.Component {
    render() {
        return (
            <div>
                <Routes>
                    <Route path='/solution' element={<Solution />} />
                    <Route path='/template' element={<Template />} />
                    <Route path='/library' element={<Library />} />
                    <Route path='/tutorial' element={<Tutorial />} />
                    <Route path='/tutorial/detail' element={<TutorialDetail />} />
                    <Route path='/*' element={<Home />} />
                </Routes>
            </div>
        )
    }
}

export default ContentMain